const instaHelpService = {
  title: "Insta Help",
  icon: "⚡",
  rateCardKey: "insta-help",
  shortDescription:
    "Quick on-demand help for simple errands, lifting, movement, setup, and urgent small tasks.",
  longDescription:
    "Book fast-response help for small urgent tasks such as item movement, simple assembly support, minor home help, quick errands, or short manpower assistance.",
  consultationNote:
    "Specialized skilled work should be booked under the right service category instead of Insta Help.",
  responsePromise:
    "Designed for fast task support based on nearby availability and task clarity.",
  warrantyPolicy:
    "Scope must remain simple and clearly defined; task suitability is important for safe completion.",
  subServices: [
    {
      id: "insta-help-30",
      title: "Quick Help - 30 Minutes",
      icon: "⏱️",
      group: "Short Tasks",
      description:
        "Fast small-task support such as carrying, shifting, setup, or simple help.",
      basePrice: 199,
      priceType: "fixed",
      duration: "30 mins",
      warranty: "Task completion only",
      unit: "slot",
    },
    {
      id: "insta-help-60",
      title: "Quick Help - 60 Minutes",
      icon: "🛠️",
      group: "Short Tasks",
      description:
        "Extended small-task support for one helper visit up to one hour.",
      basePrice: 349,
      priceType: "fixed",
      duration: "60 mins",
      warranty: "Task completion only",
      unit: "slot",
    },
    {
      id: "insta-help-120",
      title: "Quick Help - 2 Hours",
      icon: "📦",
      group: "Short Tasks",
      description:
        "Two-hour support for slightly larger small-task bundles or moving assistance.",
      basePrice: 599,
      priceType: "fixed",
      duration: "2 hrs",
      warranty: "Task completion only",
      unit: "slot",
    },
    {
      id: "insta-help-custom",
      title: "Custom Quick Task Review",
      icon: "📋",
      group: "Consultation",
      description:
        "Use this if the quick task scope is unclear and needs suitability confirmation first.",
      basePrice: 149,
      priceType: "inspection",
      duration: "10-20 mins",
      warranty: "Consultation only",
      unit: "consult",
    },
  ],
};

export default instaHelpService;